import styled, { css, keyframes } from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexColumn } from "./common.styles";
import WarningIcon from "@mui/icons-material/Warning";
import AddIcon from "@mui/icons-material/Add";
import { fontWeights } from "healthex-common/weights";
import CircularProgress from "@mui/material/CircularProgress";
export const LocationsListContainer = styled(FlexColumn) `
    width: 100%;
    box-sizing: border-box;
    gap: 12px;
    flex: 1 0 0;
`;
export const SectionContainer = styled(FlexColumn) `
    opacity: ${(props) => (props.shouldDelay ? 0 : 1)};

    ${(props) => props.shouldDelay &&
    `
            animation: fadeInSection 300ms ease-in forwards;
            animation-delay: 500ms;
        `}

    @keyframes fadeInSection {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;
export const SectionLabel = styled.span `
    margin-bottom: 8px;
    font-size: 13px;
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_lighter};
    line-height: normal;
`;
const fadeInCard = keyframes `
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
export const AnimatedCardWrapper = styled.div `
    width: 100%;

    ${(props) => props.shouldDelay && props.animate
    ? css `
                  opacity: 0;
                  animation: ${fadeInCard} 300ms ease-in forwards;
                  animation-delay: 500ms;
              `
    : css `
                  opacity: 1;
              `}
`;
export const AddProviderContainer = styled(FlexColumn) `
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 6px;
    background: ${colors.blue_10};
    border: 1px solid ${colors.blue_10};
    opacity: 0.8;
    align-self: center;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-sizing: border-box;
`;
export const AddProviderIcon = styled(AddIcon) `
    width: 24px;
    height: 24px;
`;
export const ErrorIconContainer = styled.div `
    position: relative;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background-color: ${colors.sunset_12};
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const Warning = styled(WarningIcon) `
    width: 40px;
    height: 40px;
    color: ${colors.sunset_main};
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
    }
`;
export const LocationCardWrapper = styled.div `
    position: relative;
    width: 100%;
`;
export const LoadingOverlay = styled.div `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    z-index: 1;
`;
export const LoadingSpinner = styled(CircularProgress) `
    color: ${colors.navy_main} !important;
`;
export const FastenErrorText = styled.div `
    color: ${colors.tulip_main};
    font-size: 14px;
    text-align: left;
`;
